<div #formContainer></div>

<div class="form-wrapper" *ngIf="environment.newsletterProvider === 'placeholder'">
	<img
		class="dimers-logo"
		alt=""
		loading="lazy"
		[src]="environment.defaultLogo"
	/>
	<h2 class="m-bottom-30 header-text">
		{{ environment.newsletterPromptTitle || ("Get More From " + environment.siteTitle) }}
	</h2>
	<div class="subhead-text">
		{{ environment.newsletterPromptSubtitle || "Join our mailing list to unlock sports betting picks and offers." }}
	</div>
	<div
		class="form"
		*ngIf="!formSent"
		ref="form"
	>

		<input
			type="email"
			[(ngModel)]="email"
			placeholder="Email"
			name="email"
			ngDefaultControl
			(keyup)="verifyForm()"
		>

		<div
			color="primary"
			class="submit-button"
			[class.button-enabled-yellow]="formValid && !formSending"
			[class.button-disabled-yellow]="!formValid || formSending"
			(click)="sendEmail()"
		>
			{{ formSending ? 'Please wait...' : 'Sign Me Up' }}
		</div>
	</div>
	<div class="send-info"
		*ngIf="formSent && !formError"
	>
		Thanks for joining. Stay tuned for more!
	</div>
	<div
		*ngIf="formError"
		class="send-info"
	>
		Sorry, something went wrong sending your details. Please try again.
	</div>
	<div class="disclaimer">
		<span *ngIf="environment.newsletterPromptTermsText" [innerHTML]="environment.newsletterPromptTermsText">

		</span>
		<span *ngIf="!environment.newsletterPromptTermsText">
			You can unsubscribe at any time. By signing up you agree to our
			<a href="/terms-of-service" target="_blank">Terms of Service</a> and
			<a href="/privacy-policy" target="_blank">Privacy Policy</a>.
		</span>
		
	</div>
</div>